import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { AccountFeature } from '../../common/types/Accounts';
import { useGetIsAccountFeatureDisabled } from '../../hooks/useIsAccountFeatureDisabled';

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

type EnforceAccountFeature = {
  accountFeature: AccountFeature;
};

type EnforceAllAccountFeatures = {
  enforceAllFeatures: AccountFeature[];
};

type EnforceAnyAccountFeatures = {
  enforceAnyFeatures: AccountFeature[];
};

type EnforceCriteria =
  | EnforceAccountFeature
  | EnforceAllAccountFeatures
  | EnforceAnyAccountFeatures;

type BaseProps = {
  children: any;
};

export type EnforceAccountFeatureToggleOwnProps = BaseProps & EnforceCriteria;

export type EnforceAccountFeatureToggleProps =
  EnforceAccountFeatureToggleOwnProps;

const isSingleCriteria = (
  props: EnforceAccountFeatureToggleProps,
): props is BaseProps & EnforceAccountFeature => {
  return !!(props as BaseProps & EnforceAccountFeature).accountFeature;
};

const isAllCriteria = (
  props: EnforceAccountFeatureToggleProps,
): props is BaseProps & EnforceAllAccountFeatures => {
  return !!(props as BaseProps & EnforceAllAccountFeatures).enforceAllFeatures;
};

const isAnyCriteria = (
  props: EnforceAccountFeatureToggleProps,
): props is BaseProps & EnforceAnyAccountFeatures => {
  return !!(props as BaseProps & EnforceAnyAccountFeatures).enforceAnyFeatures;
};

const EnforceAccountFeatureToggle: React.FC<
  EnforceAccountFeatureToggleProps
> = props => {
  const getIsAccountFeatureDisabled = useGetIsAccountFeatureDisabled();

  let passes = false;
  if (isSingleCriteria(props)) {
    passes = !getIsAccountFeatureDisabled(props.accountFeature);
  } else if (isAllCriteria(props)) {
    passes = props.enforceAllFeatures.every(
      _ => !getIsAccountFeatureDisabled(_),
    );
  } else if (isAnyCriteria(props)) {
    passes = !!props.enforceAnyFeatures.find(
      _ => !getIsAccountFeatureDisabled(_),
    );
  } else {
    console.error(
      'No account feature criteria pass to EnforceAccountFeatureToggle element.  The children will not be rendered',
    );
  }

  return passes ? props.children : null;
};

export default React.memo(EnforceAccountFeatureToggle);
